/**
 * @file banner
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class Banner extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    return (
      <div id="ban">
        <div className="text">
          <div className="text-one">
            <div className="dui"></div><div className="dui-a">种类齐全的课程配置</div>
          </div>
          <div className="text-two">
            <div className="dui-one"></div><div className="dui-b">循序渐进的课程体系</div>
          </div>
          <div className="text-three">
            <span className="dui-c">完美匹配您的中文学习需求</span>
          </div>
        </div>

        <div className="nothing"></div>


      </div>
    )
  }
}

export default Banner
